<template>
    <template v-if="uiLoading">
        <div :class="['pt-skeleton', animated ? 'is-animated' : '']" v-bind="$attrs">
            <template v-for="i in count" :key="i">
                <slot v-if="loading" name="template">
                    <pt-skeleton-item class="is-first" variant="p" />
                    <pt-skeleton-item
                        v-for="item in rows"
                        :key="item"
                        :class="{
                            'pt-skeleton__paragraph': true,
                            'is-last': item === rows && rows > 1,
                        }"
                        variant="p"
                    />
                </slot>
            </template>
        </div>
    </template>
    <template v-else>
        <slot v-bind="$attrs"></slot>
    </template>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import SkeletonItem from '../../skeleton-item/';
import { useThrottleRender } from '../../hooks';

export default defineComponent({
    name: 'PtSkeleton',
    components: {
        [SkeletonItem.name]: SkeletonItem,
    },
    props: {
        animated: {
            type: Boolean,
            default: false,
        },
        count: {
            type: Number,
            default: 1,
        },
        rows: {
            type: Number,
            default: 3,
        },
        loading: {
            type: Boolean,
            default: true,
        },
        throttle: {
            type: Number,
        },
    },
    setup(props) {
        const innerLoading = computed(() => {
            return props.loading;
        });

        const uiLoading = useThrottleRender(innerLoading, props.throttle);

        return {
            uiLoading,
        };
    },
});
</script>

<style lang="scss" src="../style/skeleton.scss" />
